module.exports = __webpack_public_path__ + "img/earth-night-resized.3dce4089.jpg";